import React, { useEffect, useState } from 'react';
import HighSchoolDetails from './blocks/HighSchoolDetails';
import SubjectDetails from './blocks/SubjectDetails';
import QualificationDetails from './blocks/QualificationDetails';
import PersonalDocuments from './blocks/PersonalDocuments';
import Swal from 'sweetalert2';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    GetUserEducationDetails,
    ProfileCertificateService,
    ProfilePersonalDocService,
    RemoveMyHighQualificationCertificateService,
    RemoveMyPersonalDocumentsService,
    UpdateUserEducationDetails,
} from '../../services/ProfileService';
import DownloadCertificate from './blocks/DownloadCertificate';
import { useSelector } from 'react-redux';
import { StandardButton } from '../common/GlobalElements/StandardButton';
import { Heading6, LabelMedium } from '../common/GlobalElements/Typography';
import { ContainerWrapper } from '../common/GlobalElements/Wrappers';
import { tokens } from '../../public/tokens';
const EducationalDetails = () => {
    const [detail, setDetail] = useState({});
    const [refresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    const userDetail = useSelector((state) => state.user);

    useEffect(() => {
        GetUserEducationDetails()
            .then((res) => {
                if (res.status === 200) {
                    setDetail(res.data);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [refresh]);

    const educationSchema = Yup.object({
        high_year: Yup.string().required('Matriculated year is required'),
        high_name: Yup.string().required('School name is required'),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            high_name: detail?.high_name ? detail?.high_name : '',
            high_year: detail?.high_year ? detail?.high_year : '',
            metric_certificates: detail?.userMetricsFiles ? detail?.userMetricsFiles : [],
            subjects: detail?.subjects ? detail?.subjects : [],
            highQualification: detail?.userHighQualification ? detail?.userHighQualification : [],
        },
        validationSchema: educationSchema,
        onSubmit: (values) => {
            setLoading(true);
            const payload = {
                high_year: values.high_year,
                high_name: values.high_name,
                high_qualifications: values.highQualification.map((qual) => ({
                    id: qual?.id,
                    qualification: qual?.qualification,
                    place: qual?.place,
                    year: qual?.year,
                })),
                subjects: values.subjects.map((sub) => ({
                    id: sub?.id,
                    student: sub?.student,
                    subject: sub?.subject,
                    mark: sub?.mark,
                    active: sub?.active,
                })),
            };
            console.log(payload);
            UpdateUserEducationDetails(payload)
                .then((res) => {
                    if (res.status === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Updated successfully',
                        });
                        setRefresh(!refresh);
                    }
                })
                .catch((err) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: err.response.data.message,
                    });
                })
                .finally(() => {
                    setLoading(false);
                });
        },
    });

    const { values, errors, touched, setValues, setFieldValue, handleChange, handleBlur, handleSubmit } = formik;

    const handleFileChange = (e) => {
        if (e.target.files.length) {
            const formInputs = new FormData();
            formInputs.append('doc', e.target.files[0]);
            formInputs.append('dt', 'metric_certificate');

            Swal.fire({
                title: 'File Uploading....',
                onOpen: function () {
                    Swal.showLoading();
                },
            });
            ProfilePersonalDocService(formInputs)
                .then((res) => {
                    Swal.close();
                    if (res.status === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Updated successfully',
                        });
                        setRefresh(!refresh);
                    }
                })
                .catch((error) => {
                    Swal.close();
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error.response.data.message,
                    });
                });
        }
    };

    const handleRemoveFile = (rowId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: tokens.colors.brand.blue[500],
            cancelButtonColor: tokens.colors.brand.red[500],
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                RemoveMyPersonalDocumentsService({ rowId, dt: 'metric_certificate' })
                    .then((res) => {
                        if (res.status === 200) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: 'Personal document removed successfully',
                            });
                            setRefresh(!refresh);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        });
    };

    const handleRemoveHighQualCertFile = (rowId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: tokens.colors.brand.blue[500],
            cancelButtonColor: tokens.colors.brand.red[500],
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                RemoveMyHighQualificationCertificateService({ rowId })
                    .then((res) => {
                        if (res.status === 200) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: 'Certificate removed successfully',
                            });
                            setRefresh(!refresh);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        });
    };

    const handleHighQualCertFileChange = (e, id) => {
        if (e.target.files.length) {
            const formInputs = new FormData();
            formInputs.append('certificate', e.target.files[0]);
            formInputs.append('rowId', id);
            Swal.fire({
                title: 'File Uploading....',
                onOpen: function () {
                    Swal.showLoading();
                },
            });
            ProfileCertificateService(formInputs)
                .then((res) => {
                    Swal.close();
                    if (res.status === 200) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success',
                            text: 'Updated successfully',
                        });
                        setRefresh(!refresh);
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error.response.data.message,
                    }).then((result) => {});
                });
        }
    };

    const handleAddNewSubject = () => {
        const prevValue = [...values.subjects];
        prevValue.push({
            id: 0,
            student: userDetail?.id,
            subject: '',
            mark: '',
            active: 1,
        });
        setValues({
            ...values,
            subjects: [...prevValue],
        });
    };

    const handleRemoveSubject = (index) => {
        const currentValue = [...values.subjects];
        currentValue.splice(index, 1);

        setValues({ ...values, subjects: [...currentValue] });
    };

    const handleChangeSubjectName = (e, idx) => {
        const currentValue = [...values.subjects];
        currentValue[idx].subject = e.target.value;

        setValues({ ...values, subjects: [...currentValue] });
    };

    const handleChangeSubjectMark = (e, idx) => {
        const currentValue = [...values.subjects];
        currentValue[idx].mark = e.target.value;

        setValues({ ...values, subjects: [...currentValue] });
    };

    const handleAddNewQualification = () => {
        const currentValue = [...values.highQualification];
        currentValue.push({
            id: 0,
            student: userDetail?.id,
            qualification: '',
            place: '',
            year: '',
            active: 1,
            temp_id: '0',
            files: [],
        });

        setValues({
            ...values,
            highQualification: [...currentValue],
        });
    };

    const handleRemoveQualification = (index) => {
        const currentValue = [...values.highQualification];
        currentValue.splice(index, 1);
        setValues({
            ...values,
            highQualification: [...currentValue],
        });
    };

    const handleChangeQualFields = (e, idx, field) => {
        const currentValue = [...values.highQualification];
        currentValue[idx][field] = e.target.value;
        setValues({
            ...values,
            highQualification: [...currentValue],
        });
    };

    return (
        <ContainerWrapper className="card card-profile-info-card">
            <Heading6 className="mb-4">High School</Heading6>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group" title="School Name">
                            <LabelMedium>School Name</LabelMedium>
                            <input
                                type="text"
                                className={
                                    'form-control' + (errors.high_name && touched.high_name ? ' is-invalid' : '')
                                }
                                placeholder="School Name"
                                value={values.high_name}
                                name="high_name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group" title="Year Matriculated">
                            <LabelMedium>Year Matriculated</LabelMedium>
                            <input
                                type="text"
                                className={
                                    'form-control' + (errors.high_year && touched.high_year ? ' is-invalid' : '')
                                }
                                placeholder="Year Matriculated"
                                value={values.high_year}
                                name="high_year"
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <LabelMedium>Matric Certificate</LabelMedium>
                        <div className="form-group atttach-file m-0">
                            <StandardButton as="label" outline={true} variant="secondary">
                                <i className="fal fa-upload"></i>
                                Upload
                                <input
                                    type="file"
                                    className="form-control form-control-aatch-file"
                                    onChange={(e) => handleFileChange(e)}
                                />
                            </StandardButton>
                        </div>
                        <div className="frm-group">
                            <ul className="list-unstyled attached-file-ul m-0">
                                {values.metric_certificates.map((document) => {
                                    return (
                                        <li key={document.id}>
                                            <DownloadCertificate
                                                item={document}
                                                canRemove={true}
                                                handleRemoveFile={handleRemoveFile}
                                            />
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="subject-container">
                    <Heading6 className="mb-4">Subject Details</Heading6>
                    {values?.subjects.map((subject, key) => (
                        <div className="row align-items-center mb-sm-3" key={key}>
                            <div className="col-md-3">
                                <div className="form-group" title="Subject">
                                    <LabelMedium>Subject</LabelMedium>
                                    <input
                                        type="text"
                                        className={'form-control'}
                                        placeholder="Subject"
                                        value={subject?.subject}
                                        name="subject"
                                        onChange={(e) => {
                                            handleChangeSubjectName(e, key);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group" title="Symbol(%)">
                                    <LabelMedium>Symbol(%)</LabelMedium>
                                    <input
                                        type="number"
                                        className={'form-control'}
                                        value={subject?.mark}
                                        name="mark"
                                        onChange={(e) => {
                                            handleChangeSubjectMark(e, key);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-1">
                                <StandardButton
                                    type="button"
                                    variant="danger"
                                    isRounded={true}
                                    onClick={() => handleRemoveSubject(key)}
                                    title="Delete"
                                >
                                    <i className="fal fa-trash-alt"></i>
                                </StandardButton>
                            </div>
                        </div>
                    ))}
                    <StandardButton
                        variant="dark"
                        type="button"
                        title="Add Subject"
                        className="mb-3"
                        onClick={() => {
                            handleAddNewSubject();
                        }}
                    >
                        <i className="fal fa-plus"></i> Add Subject
                    </StandardButton>
                </div>
                <hr />
                <div className="qualification-container">
                    <Heading6 className="mb-4">High Qualification</Heading6>
                    {values.highQualification.map((qualification, key) => (
                        <div className="row mb-sm-3" key={key}>
                            <div className="col-md-3">
                                <div className="form-group" title="Qualification">
                                    <LabelMedium>Qualification</LabelMedium>
                                    <input
                                        type="text"
                                        className={'form-control'}
                                        placeholder="Qualification"
                                        value={qualification.qualification}
                                        name="qualification"
                                        onChange={(e) => {
                                            handleChangeQualFields(e, key, 'qualification');
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group" title="Place of Study">
                                    <LabelMedium>Place of Study</LabelMedium>
                                    <input
                                        type="text"
                                        className={'form-control'}
                                        placeholder="Place of Study"
                                        value={qualification.place}
                                        name="place"
                                        onChange={(e) => {
                                            handleChangeQualFields(e, key, 'place');
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-2 col-6">
                                <div className="form-group" title="Year Graduated">
                                    <LabelMedium>Year Graduated</LabelMedium>
                                    <input
                                        type="number"
                                        className={'form-control'}
                                        placeholder="Year Graduated"
                                        value={qualification.year}
                                        name="year"
                                        onChange={(e) => {
                                            handleChangeQualFields(e, key, 'year');
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <LabelMedium>Certificate</LabelMedium>
                                {qualification.files.length > 0 ? (
                                    <div className="frm-group">
                                        <ul className="list-unstyled attached-file-ul m-0">
                                            {qualification.files.map((document) => {
                                                return (
                                                    <li key={document.id} className="p-0">
                                                        <DownloadCertificate
                                                            item={document}
                                                            canRemove={true}
                                                            canEdit={true}
                                                            handleRemoveFile={handleRemoveHighQualCertFile}
                                                            handleFileEdit={(e) => {
                                                                handleHighQualCertFileChange(e, qualification.id);
                                                            }}
                                                        />
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                ) : (
                                    <div className="form-group atttach-file m-0">
                                        <StandardButton as="label" outline={true} variant="secondary">
                                            <i className="fal fa-paperclip"></i>
                                            <span>Add Attachment</span>
                                            <input
                                                type="file"
                                                className="form-control-aatch-file"
                                                onChange={(e) => handleHighQualCertFileChange(e, qualification.id)}
                                            />
                                        </StandardButton>
                                    </div>
                                )}
                            </div>
                            <div className="col-md-1 align-items-center d-flex">
                                <StandardButton
                                    type="button"
                                    variant="danger"
                                    isRounded={true}
                                    onClick={() => handleRemoveQualification(key)}
                                    title="Remove Qualification"
                                >
                                    <i className="fal fa-trash-alt"></i>
                                </StandardButton>
                            </div>
                        </div>
                    ))}
                    <StandardButton
                        variant="dark"
                        title="Add Qualification"
                        className="mb-3"
                        type="button"
                        onClick={() => {
                            handleAddNewQualification();
                        }}
                    >
                        <i className="fal fa-plus"></i> Add Qualification
                    </StandardButton>
                </div>
                <div className="form-group form-group-save-cancel d-flex gap-2">
                    <StandardButton type="submit" title="Save" disabled={loading}>
                        {loading ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-save"></i>}
                        Save Changes
                    </StandardButton>
                    <StandardButton
                        variant="danger"
                        type="button"
                        onClick={() => {
                            formik.resetForm();
                        }}
                        title="Cancel"
                    >
                        <i className="fal fa-times"></i>
                        Cancel
                    </StandardButton>
                </div>
            </form>
        </ContainerWrapper>
    );
};

export default EducationalDetails;
